import { findIndex, isEqual } from 'lodash'
import { create } from 'zustand'
import {
    archiveThread,
    changeTheadAssistant,
    deleteThread,
    getReplyList,
    getRequestDetail,
    getRequestList,
    patchThead,
    postReply,
    postThead,
} from '../api/request'
import {
    BodyCreateReplyApiV1ChatAppReplyPost,
    ReplyDTO,
    ReplyListApiV1ChatAppReplyGetParams,
    ReplyListOutputDTO,
    TelegramConnectAssistantModel,
    ThreadArchiveApiV1ChatAppThreadThreadIdArchivePostParams,
    ThreadArchiveModel,
    ThreadConnectAssistantApiV1ChatAppThreadThreadIdConnectAssistantPostParams,
    ThreadDTO,
    ThreadDeleteApiV1ChatAppThreadThreadIdDeleteParams,
    ThreadDeleteOutputDTO,
    ThreadDetailApiV1ChatAppThreadThreadIdGetParams,
    ThreadListApiV1ChatAppThreadGetParams,
    ThreadListOutputDTO,
    ThreadShortDTO,
    ThreadUpdateRequestModel,
    UpdateThreadApiV1ChatAppThreadThreadIdPutParams,
} from '../swagger/dto'

interface DialogState {
    error?: string
    isLoading: boolean
    isLoadingReply: boolean
    theadList?: ThreadShortDTO[]
    theadListTotal?: undefined
    replyList?: ReplyDTO[]
    replyListTotal?: undefined
    replyListOffset?: number
    idTheadActive?: number
    indexActiveThead?: string

    errorChangeThreadAssistant?: string
    isLoadingChangeThreadAssistant?: boolean

    idActiveReply?: string
    idActiveEditReply?: string

    userSendReply: boolean
    isRecording: boolean
    threadIdNew?: string
    setThreadIdNew: () => void
    idCreateNewTheadBuff?: string

    setIdAndIndexActiveThead: (id: string, index: string) => void
    setIdActiveReply: (id?: string) => void
    setIdActiveEditReply: (id?: string) => void

    fetchTheadList: (params?: ThreadListApiV1ChatAppThreadGetParams) => Promise<ThreadListOutputDTO>

    isFetchTheadList: boolean
    isErrorFetchTheadList: boolean

    theadDetail?: ThreadDTO
    fetchTheadDetail: (
        params: ThreadDetailApiV1ChatAppThreadThreadIdGetParams,
    ) => Promise<ThreadDTO>
    isDoneFetchTheadDetail: boolean
    isErrorFetchTheadDetail: boolean

    isScrollBottom: boolean
    fetchThreadDetail: (
        params: ThreadDetailApiV1ChatAppThreadThreadIdGetParams,
    ) => Promise<ThreadDTO>
    fetchReplyList: (params?: ReplyListApiV1ChatAppReplyGetParams) => Promise<ReplyListOutputDTO>
    isErrorFetchReplyList: boolean
    refreshReplyList: (params: ReplyListApiV1ChatAppReplyGetParams) => Promise<ThreadListOutputDTO>

    createReply: (params: BodyCreateReplyApiV1ChatAppReplyPost) => Promise<ReplyDTO>
    changeThreadAssistant: (
        params: ThreadConnectAssistantApiV1ChatAppThreadThreadIdConnectAssistantPostParams,
        payload: TelegramConnectAssistantModel,
    ) => Promise<ThreadDTO>

    updateThread: (
        params: UpdateThreadApiV1ChatAppThreadThreadIdPutParams,
        payload: ThreadUpdateRequestModel,
        type?: 'name' | 'count',
    ) => Promise<ReplyDTO>
    isLoadingUpdateThreadName: boolean
    errorUpdateThreadName?: boolean

    createThread: (assistantId?: string) => Promise<ThreadDTO>
    setReplyListOffset: (offset: number) => void
    setIsErrorFetchReplyList: (isError: boolean) => void
    isLoadingCreateThread: boolean
    errorCreateThread?: boolean

    createNewReply: () => void

    deleteThread: (
        params: ThreadDeleteApiV1ChatAppThreadThreadIdDeleteParams,
    ) => Promise<ThreadDeleteOutputDTO>
    isLoadingDeleteThread: boolean
    errorDeleteThread?: boolean

    archiveThread: (
        params: ThreadArchiveApiV1ChatAppThreadThreadIdArchivePostParams,
        data: ThreadArchiveModel,
    ) => Promise<ThreadDTO>
    isLoadingArchiveThread: boolean
    errorArchiveThread?: boolean
}
export const useDialogStore = create<DialogState>((set, get) => ({
    error: undefined,
    isLoading: false,
    isLoadingReply: false,
    idTheadActive: undefined,
    indexActiveThead: undefined,
    idActiveReply: undefined,
    idCreateNewTheadBuff: undefined,
    userSendReply: false,
    isRecording: false,

    isLoadingUpdateThreadName: false,
    errorUpdateThreadName: undefined,

    errorChangeThreadAssistant: undefined,
    isLoadingChangeThreadAssistant: false,

    theadDetail: undefined,
    isDoneFetchTheadDetail: false,
    isErrorFetchTheadDetail: undefined,

    theadList: undefined,
    theadListTotal: undefined,
    replyList: undefined,
    replyListTotal: undefined,
    replyListOffset: 0,
    isErrorFetchReplyList: false,

    isCreateTheadReply: false,

    isFetchTheadList: false,
    isErrorFetchTheadList: false,
    isScrollBottom: false,

    threadIdNew: undefined,
    createThread: async (assistantId) => {
        try {
            set({
                isLoadingCreateThread: true,
                errorCreateThread: undefined,
            })
            const theadListNew = get().theadList ?? []
            const thread = {
                assistant_id: assistantId ?? null,
                name: 'Название чата',
                agent: 'GPT4_LATEST',
                memory_message_count: 10,
            }
            const treadNew = await postThead(thread)

            set({
                threadIdNew: treadNew.id,
                theadList: [treadNew, ...theadListNew],
                replyList: [],
                isLoadingCreateThread: false,
            })
        } catch (error) {
            set({
                errorCreateThread: 'Ошибка! Не удалось создать новый диалог!',
                isLoadingCreateThread: false,
            })
        }
    },
    setThreadIdNew: () => {
        set({
            threadIdNew: undefined,
        })
    },
    createNewReply: () => {
        set({
            replyList: [],
        })
    },
    setIsRecording: (isRecording: boolean) => {
        set({
            isRecording: isRecording,
        })
    },
    setIdActiveReply: (id: string) => {
        set({
            idActiveReply: id,
        })
    },

    setReplyListOffset: (offset: number) => {
        set({
            replyListOffset: offset,
        })
    },
    setIsErrorFetchReplyList: (isError: boolean) => {
        set({
            isErrorFetchReplyList: isError,
        })
    },
    setIdActiveEditReply: (id: string) => {
        set({
            idActiveEditReply: id,
        })
    },
    // setIdAndIndexActiveThead: (id, index) => {
    //     set({
    //         idActiveThead: id,
    //         indexActiveThead: index,
    //     })
    // },
    fetchTheadList: async (params) => {
        try {
            set({
                theadList: undefined,
                isLoading: true,
                error: undefined,
                isErrorFetchTheadList: false,
            })

            const data = await getRequestList(params)
            const theadListOld = get().theadList

            set({
                theadList: data.objects,
                theadListTotal: data.total_count,
                indexActiveThead: 0,
                isLoading: false,
                isFetchTheadList: true,
            })
        } catch (error) {
            set({
                isErrorFetchTheadList: true,
                error: 'Неверный логин или пароль',
                isLoading: false,
            })
        }
    },
    fetchTheadDetail: async (params) => {
        try {
            set({
                isDoneFetchTheadDetail: false,
                isErrorFetchTheadDetail: undefined,
                theadDetail: undefined,
            })

            const data = await getRequestDetail(params)
            if (data.assistant_id === null) {
                data.assistant_id = 'null'
            }
            set({
                theadDetail: data,
                isDoneFetchTheadDetail: true,
            })
        } catch (error) {
            set({
                isErrorFetchTheadDetail: 'Произошла ошибка! Повторите попытку позже.',
                isDoneFetchTheadDetail: false,
            })
        }
    },

    refreshReplyList: async (params) => {
        try {
            const replyListNew = await getReplyList(params)
            const replyListOld = get().replyList
            const isUpdate = !isEqual(replyListNew.objects, replyListOld)

            if (isUpdate) {
                set({
                    replyList: replyListNew.objects.reverse(),
                })
            }
        } catch (error) {
            set({
                error: 'ошибка',
            })
        }
    },
    isLoadingFetchReplyList: false,
    fetchReplyList: async (params) => {
        try {
            set({
                replyList: undefined,
                isLoadingReply: true,
                isLoadingFetchReplyList: true,
                error: undefined,
                isErrorFetchReplyList: false,
            })

            const data = await getReplyList(params)
            const replyListOld = get().replyList ?? []
            const idTheadActiveOld = get().idTheadActive
            set({
                replyList:
                    idTheadActiveOld !== params?.thread_id
                        ? data.objects.reverse()
                        : [...data.objects.reverse(), ...replyListOld],
                //,
                replyListOffset: params?.offset,
                replyListTotal: data?.total_count,
                idTheadActive: params?.thread_id,
                isScrollBottom: idTheadActiveOld !== params?.thread_id,
                isLoadingFetchReplyList: false,
            })
        } catch (error) {
            set({
                isErrorFetchReplyList: true,
                error: 'ошибка',
            })
        } finally {
            set({
                isLoadingFetchReplyList: false,
                isLoadingReply: false,
            })
        }
    },

    updateThread: async (params, payload, type) => {
        try {
            set({
                errorUpdateThreadName: undefined,
                isLoadingUpdateThreadName: true,
            })
            const treadEdited = await patchThead(params, payload)
            const theadListBuff = get().theadList ?? []
            const indexEditThead = findIndex(theadListBuff, { id: params.threadId })
            theadListBuff[indexEditThead] = treadEdited

            if (treadEdited.assistant_id === null) {
                treadEdited.assistant_id = 'null'
            }
            set({
                theadDetail: treadEdited,
                theadList: [...theadListBuff],
                isLoadingUpdateThreadName: false,
            })
        } catch (error) {
            set({
                errorUpdateThreadName: 'Ошибка',
                isLoadingUpdateThreadName: false,
            })
        }
    },

    isLoadingDeleteThread: false,
    errorDeleteThread: undefined,
    deleteThread: async (params) => {
        try {
            set({
                errorDeleteThread: undefined,
                isLoadingDeleteThread: true,
            })
            await deleteThread(params)

            set({
                replyListOffset: 0,
                theadDetail: undefined,
                replyList: undefined,
                isLoadingDeleteThread: false,
            })
        } catch (error) {
            set({
                errorDeleteThread: 'Ошибка',
                isLoadingDeleteThread: false,
            })
        }
    },

    isLoadingArchiveThread: false,
    errorArchiveThread: undefined,
    archiveThread: async (params, data) => {
        try {
            set({
                errorArchiveThread: undefined,
                isLoadingArchiveThread: true,
            })
            await archiveThread(params, data)

            set({
                replyListOffset: 0,
                replyList: undefined,
                theadDetail: undefined,
                isLoadingArchiveThread: false,
            })
        } catch (error) {
            set({
                errorArchiveThread: 'Ошибка',
                isLoadingArchiveThread: false,
            })
        }
    },

    createReply: async (params) => {
        try {
            set({
                isCreateTheadReply: true,
                // isLoadingReply: true,
                errorCreateReply: undefined,
            })
            const reply = await postReply(params)
            const replyListNew = get().replyList ?? []
            set({
                replyList: [...replyListNew, reply?.user_reply, reply?.agent_reply],
                userSendReply: true,
            })
        } catch (error) {
            if (error?.response?.data?.detail?.error_code === 'NoBalanceForOperation') {
                set({
                    errorCreateReply:
                        'Недостаточно средств для проведения операции, требуется пополнить баланс',
                })
            } else {
                set({
                    errorCreateReply: 'Произошла ошибка! Повторите попытку позже.',
                })
            }
        } finally {
            set({
                isCreateTheadReply: false,
                // isLoadingReply: false,
            })
        }
    },
    changeThreadAssistant: async (params, payload) => {
        try {
            set({
                errorChangeThreadAssistant: undefined,
                isLoadingChangeThreadAssistant: true,
            })

            const theadModified = await changeTheadAssistant(params, payload)

            if (theadModified.assistant_id === null) {
                theadModified.assistant_id = 'null'
            }

            set({
                theadDetail: theadModified,
            })
        } catch (error) {
            set({
                errorChangeThreadAssistant: 'Произошла ошибка! Повторите попытку позже.',
            })
        } finally {
            set({
                isLoadingChangeThreadAssistant: false,
            })
        }
    },
}))
